import React from "react";
import FixedAssetsModernizationsGenericSkeleton from "./FixedAssetsModernizationsGenericSkeleton";

function FixedAssetsModernizationsDetailsSkeleton() {
  return (
    <>
      <FixedAssetsModernizationsGenericSkeleton />
    </>
  );
}

export default FixedAssetsModernizationsDetailsSkeleton;
